import React, {Component} from 'react';
const { connect } = require('react-redux');
import isMobile from "ismobilejs";

import { Link } from 'components/ReactRouterDomLocalized';
import paths from 'paths';
import {t} from '../l10n';

import Loading from 'components/Loading';

import {getFooter} from 'reducers/footer';

import 'sass/footer.scss';

class Footer extends Component {
    static fetchData({dispatch}) {
        return dispatch(getFooter());
    }

    componentDidMount() {
        let {dispatch, footer} = this.props;

        if (!footer) {
            this.constructor.fetchData({dispatch});
        }
    }

    render() {
        let {footer, browser} = this.props;

        if (!footer) {
            return <Loading/>;
        }

        return (
            <footer>
                <div className="content">
                    {footer.map((group, index1) =>
                        <div className="menu" key={index1}>
                            <p className="name">{group.name}</p>
                            {group.items.map((item, index2) =>
                                <p key={index2}><a href={item.site_link} title={item.site_name} target="_blank">{item.site_name}</a></p>
                            )}
                            {!isMobile.any && index1 === 0 && (
                                <div className="auth-links">
                                    <Link to={paths.login.path}>
                                        {t('Log in')}
                                    </Link>
                                    <Link to={paths.register.path}>
                                        {t('Registration')}
                                    </Link>
                                </div>
                            )}
                            {isMobile.any && (
                                <div className="auth-links">
                                    <Link to={paths.login.path}>
                                        {t('Log in')}
                                    </Link>
                                    <Link to={paths.register.path}>
                                        {t('Registration')}
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </footer>
        )
    }
}

export default connect(
    state => ({
        footer: state.footer
    }),
    null
)(Footer)


// WEBPACK FOOTER //
// ./src/components/Footer.js